// extracted by mini-css-extract-plugin
export default {"docsLink":"yIfUPVpPoNcvZcWF1Q4Q"};